import { useEffect } from 'react';

import { useErrorHandler } from 'src/services';
import { useBrandTermsActions } from 'src/store';

export const usePreloadBrandTerms = (brandVoice) => {
  const handleError = useErrorHandler();
  const brandTermsActions = useBrandTermsActions();

  useEffect(() => {
    const fetchData = async () => {
      try {
        await brandTermsActions.queryBrandTerms(brandVoice.id);
      } catch (error) {
        handleError(error);
      }
    };

    if (brandVoice?.id) {
      fetchData();
    }
  }, [brandVoice, handleError, brandTermsActions]);
};
